module.exports = __webpack_public_path__ + "static/media/LOGOnegreo.eeafa252.png";